import { LeftRightDesginIcon, NewYorkPopUp } from '@Components/Common/CommonMethods';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import Cookies from 'js-cookie';
import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react'
import { RegionDropdown } from 'react-country-region-selector';
import { Controller, useForm } from 'react-hook-form';
import SignaturePad from "react-signature-canvas";
import * as yup from 'yup';

const MyselfForm = ({ mySelfState }) => {

    const [country, setCountry] = useState("US");
    const [state, setState] = useState("");
    const [newYorkCheck, setNewyorkCheck] = useState(false);
    const [stateError, setStateError] = useState();
    const [lessThenEighteen, setLessThenEighteen] = useState(false);

    const schema = yup.object().shape({
        first_name: yup.string().trim().required('this field is required'),
        // .min(3, "Enter minimum 3 character"),
        last_name: yup.string().trim().required('this field is required'),
        // .min(3, "Enter minimum 3 character"),
        address: yup.string().trim().required('this field is required'),
        city: yup.string().trim().required('this field is required'),
        sex_at_birth: yup.string().trim().required('this field is required'),
        dob: yup.string().trim().required('this field is required'),
        termscondition3: yup.bool().oneOf([true], 'Please read and accept'),
        phone_no: yup.string().typeError('Please enter only number')
            .required('this field is required')
            .matches(/^(\+\d{1,3}[- ]?)?\d{10}$/, "Phone number is not valid"),
        zipcode: yup.string().required('this field is required'),
        show_to_professional: yup.boolean().notRequired()
    });

    const { register, handleSubmit, reset, control, errors } = useForm({
        mode: "onChange", resolver: yupResolver(schema),
        defaultValues: { sex_at_birth: "M" }
    });
    useEffect(() => {
        let VALUES = {};
        if (mySelfState?.storeShippingData) {
            const { phone_number, street_address_1, country, state: stateValue, postal_code, ...others } = mySelfState?.storeShippingData;
            VALUES = {
                ...others,
                phone_no: phone_number,
                zipcode: postal_code,
                address: street_address_1,
                sex_at_birth: 'M'
            }
            setState(stateValue);

        } else {
            const { first_name, last_name, user_addresses, userdetails } = mySelfState?.profileData;
            VALUES = { first_name, last_name, sex_at_birth: 'M' }
            if (user_addresses?.length > 0) {
                VALUES = {
                    ...VALUES,
                    city: user_addresses[0]?.city,
                    zipcode: user_addresses[0]?.postal_code,
                    address: user_addresses[0]?.street_address_1,
                }
                setCountry(user_addresses[0]?.country);
                setState(user_addresses[0]?.state);
            }
            if (userdetails?.length > 0) {
                VALUES = {
                    ...VALUES,
                    dob: userdetails[0]?.birthday,
                    phone_no: userdetails[0]?.phone_number,
                }
            }
        }
        reset(VALUES);
    }, [mySelfState?.storeShippingData]);

    const sigCanvas = useRef({});
    const clear = () => sigCanvas.current.clear();

    function _InputField(fieldName, placeHolder, label = null) {
        return (
            <div className="mb-3 field-class">
                {label && <label htmlFor={fieldName}>{label}:</label>}
                <div className='wrap-field'>
                    <input type="text" className="form-control" name={fieldName} placeholder={placeHolder} ref={register} />
                </div>
                {errors[fieldName] && <span className="error">{errors[fieldName]?.message}</span>}

            </div>
        )
    }
    const handleCountryStateError = () => {
        if (state === undefined || (state === "" && stateError === undefined)) {
            setStateError("Please Select The State");
        }
    };


    return (
        <LeftRightDesginIcon>
            <form method="POST" className="signupform main-sign-frm" onSubmit={handleSubmit((data) => mySelfState?.mySelfFormSubmit({ ...data, state }, sigCanvas))}>
                <h5 style={{ textAlign: 'center' }}>Consent Form</h5>
                {_InputField("first_name", "First Name", "First Name")}
                {_InputField("last_name", "Last Name", " Last Name")}
                {_InputField("address", "Address", "Address")}
                <div className="mb-3 field-class">
                    <label>Country:</label>
                    <div className='wrap-field'>
                        <div className="select">
                            <select name="country" ref={register} onChange={(e) => setCountry(e.target.value)}>
                                <option value="US">United States</option>
                                <option value="CA">Canada</option>
                                <option value="GB">UK</option>
                                <option value="AU">Australia</option>
                                <option value="DE">Germany</option>
                                <option value="DK">Denmark</option>
                                <option value="FI">Finland</option>
                                <option value="NL">Netherlands</option>
                                <option value="SE">Sweden</option>
                                <option value="IE">Ireland</option>
                            </select>
                        </div>
                        {errors.country && <span className="error">{errors.country?.message}</span>}
                    </div>
                </div>
                <div className="mb-3 field-class">
                    <label>State:</label>
                    <div className="select">
                        <RegionDropdown
                            country={country}
                            value={state}
                            name="state"
                            valueType="short"
                            defaultOptionLabel="State"
                            countryValueType="short"
                            onChange={(val) => {
                                if (val === "NY") { setNewyorkCheck(true) } else { setNewyorkCheck(false) };
                                setState(val);
                            }}
                        />
                    </div>
                    {state === undefined ||
                        (state === "" && <span className="error">{stateError}</span>)}
                    <NewYorkPopUp open={newYorkCheck} setClose={setNewyorkCheck} />
                </div>
                {_InputField("city", "City", "City")}
                {_InputField("phone_no", "Phone Number", "Phone")}
                {_InputField("zipcode", "Zip Code", "Zip Code")}
                <div className="mb-3 field-class  radio-select">
                    <label>Gender:</label>
                    <Controller
                        name="sex_at_birth"
                        control={control} as={
                            <RadioGroup>
                                <FormControlLabel value="M" control={<Radio />} label="Male" />
                                <FormControlLabel value="F" control={<Radio />} label="Female" />
                            </RadioGroup>
                        }
                    />
                    {errors.sex_at_birth && <span className="error">{errors.sex_at_birth.message}</span>}
                </div>
                <div className="mb-3 field-class date-picker-sign">
                    <label>D.O.B:</label>
                    <input name="dob" type="date" ref={register({ required: "This field is required" })} onChange={(e) => {
                        if (e.target.value) {
                            const BIRTH_YEAR = (_.split(e.target?.value, '-')?.length > 0) ? _.split(e.target?.value, '-')[0] : null;
                            const BIRTH_MONTH = (_.split(e.target?.value, '-')?.length > 0) ? _.split(e.target?.value, '-')[1] : null;
                            const BIRTH_DATE = (_.split(e.target?.value, '-')?.length > 0) ? _.split(e.target?.value, '-')[2] : null;
                            const CURRENT_YEAR = new Date().getFullYear();
                            const CURRENT_MONTH = new Date().getMonth() + 1;
                            const CURRENT_DATE = new Date().getDate();
                            let AGE = 0;
                            if (+CURRENT_YEAR > +BIRTH_YEAR) {
                                if (CURRENT_MONTH > +BIRTH_MONTH) {
                                    AGE = +CURRENT_YEAR - +BIRTH_YEAR
                                } else if (CURRENT_MONTH < +BIRTH_MONTH) {
                                    AGE = +CURRENT_YEAR - +BIRTH_YEAR - 1;
                                } else if (CURRENT_MONTH === +BIRTH_MONTH) {
                                    if (CURRENT_DATE > +BIRTH_DATE) {
                                        AGE = +CURRENT_YEAR - +BIRTH_YEAR;
                                    } else if (CURRENT_DATE < +BIRTH_DATE) {
                                        AGE = +CURRENT_YEAR - +BIRTH_YEAR - 1;
                                    } else if (CURRENT_DATE === +BIRTH_DATE) {
                                        AGE = +CURRENT_YEAR - +BIRTH_YEAR;
                                    }
                                }
                                if (AGE < 18) {
                                    setLessThenEighteen(true);
                                } else {
                                    setLessThenEighteen(false);
                                }
                            }
                        }
                    }} />
                    {errors.dob && <span className="error">{errors.dob.message}</span>}
                </div>
                <div className="E-Signature">
                    <label>{lessThenEighteen ? "Full Name of Parent or Legal Guardian" : "E-Signature"}:</label>
                    <div className="canvas_section">
                        <SignaturePad ref={sigCanvas} canvasProps={{ name: "signature", className: "signatureCanvas" }} />
                        <div className='buttons-change'><button type="button" onClick={clear}>Change</button></div>
                    </div>
                    <span className="error">{mySelfState?.imageError}</span>
                </div>

                <div className="form-check" style={{ display: 'flex' }}>
                    <input type="checkbox" className="form-check-input" id="consent_checkbox" name="termscondition3" ref={register} />
                    <label className="form-check-label" htmlFor="consent_checkbox"></label>
                    <div className="policy">
                        By providing my
                        <a className="privacy_style" target='_blank' href='https://admin.snipnutrition.com/media/documents/SampleConsent.pdf'> information </a>
                        and signing below, I hereby consent to participate in nutrition-focused genetic testing offered by SNiP Nutrigenomics.
                    </div>
                </div>
                {(mySelfState?.isBundleProduct || Cookies.get("shareconsent")) &&
                    <div className="form-check form-group dna-share">
                        <input type="checkbox" className="form-check-input" id="dnashare" name="show_to_professional" defaultChecked={true} ref={register} />
                        <label className="form-check-label dna-share" htmlFor="dnashare"></label>
                        <div className='share-results'>
                            Please share my DNA results with my referring provider
                        </div>
                    </div>
                }

                {errors.termscondition3 && (<div style={{ color: "red" }}>{errors.termscondition3?.message}</div>)}

                <div className='sign-btn mb-3 d-flex' style={{ color: '#fff' }}>
                    <button type="button" onClick={() => mySelfState?.setBarCodeValue('')}>Back</button>

                    <button type="submit" onClick={() => handleCountryStateError()}>Submit</button>
                </div>
                {mySelfState?.success && <span>{mySelfState?.success}</span>}
                {mySelfState?.errorKitMsg && (
                    <span
                        className='error'
                        dangerouslySetInnerHTML={{ __html: mySelfState?.errorKitMsg }}
                    />
                )}            </form>
        </LeftRightDesginIcon >
    )
}
export default MyselfForm;